export default "__VITE_ASSET__DpTCyzI7__"